import { useEffect, useRef, useState, memo } from "react";

/* ================= IMAGES ================= */

import accessImg    from "../assets/images/clients/ACCESS.webp";
import absaImg      from "../assets/images/clients/absa.webp";
import asaImg       from "../assets/images/clients/ASA.webp";
import bestImg      from "../assets/images/clients/BEST.webp";
import bImg         from "../assets/images/clients/b.webp";
import calImg       from "../assets/images/clients/Cal.webp";
import cbgImg       from "../assets/images/clients/cbg.webp";
import dciImg       from "../assets/images/clients/dci.webp";
import ecoImg       from "../assets/images/clients/ecobank.webp";
import egImg        from "../assets/images/clients/EG.webp";
import fbImg        from "../assets/images/clients/FB.webp";
import fdaImg       from "../assets/images/clients/fda.webp";
import fnbImg       from "../assets/images/clients/FNB.webp";
import focosImg     from "../assets/images/clients/focos.webp";
import gcbImg       from "../assets/images/clients/GCB.webp";
import gizImg       from "../assets/images/clients/GIZ.webp";
import goldImg      from "../assets/images/clients/goldfeild.webp";
import gsImg        from "../assets/images/clients/GS.webp";
import gseImg       from "../assets/images/clients/GSE.webp";
import gtImg        from "../assets/images/clients/GT.webp";
import gtiImg       from "../assets/images/clients/gti.webp";
import hollardImg   from "../assets/images/clients/hollad.webp";
import izweImg      from "../assets/images/clients/izwe.webp";
import kaseprekoImg from "../assets/images/clients/kasepreko.webp";
import kekImg       from "../assets/images/clients/KEK.webp";
import musigaImg    from "../assets/images/clients/musiga.webp";
import nexanImg     from "../assets/images/clients/nexan.webp";
import omniImg      from "../assets/images/clients/OMNI.webp";
import pentImg      from "../assets/images/clients/PENT.webp";
import pensionImg   from "../assets/images/clients/Pension.webp";
import rbImg        from "../assets/images/clients/RB.webp";
import sbImg        from "../assets/images/clients/SB.webp";
import shallImg     from "../assets/images/clients/SHALL.webp";
import starliveImg  from "../assets/images/clients/STARLIFE.webp";
import bankImg      from "../assets/images/clients/the bank hospital.webp";
import telecelImg   from "../assets/images/clients/telecel.webp";
import torImg       from "../assets/images/clients/TOR.webp";
import ubaImg       from "../assets/images/clients/UBA.webp";
import ugImg        from "../assets/images/clients/UG.webp";
import uenerImg     from "../assets/images/clients/uener.webp";
import vraImg       from "../assets/images/clients/VRA.webp";
import vsImg        from "../assets/images/clients/VS.webp";
import wagImg       from "../assets/images/clients/WAGPC.webp";
import zenithImg    from "../assets/images/clients/zenith.webp";

/* ================= DATA (22 + 22) ================= */

const ROW1 = [
  accessImg, absaImg, asaImg, bestImg, bImg, calImg, cbgImg, dciImg,
  ecoImg, egImg, fbImg, fdaImg, fnbImg, focosImg, gcbImg, gizImg,
  goldImg, gsImg, gseImg, gtImg, gtiImg, hollardImg,
];

const ROW2 = [
  izweImg, kaseprekoImg, kekImg, musigaImg, nexanImg, omniImg, pentImg, pensionImg,
  rbImg, sbImg, shallImg, starliveImg, bankImg, telecelImg, torImg, ubaImg,
  ugImg, uenerImg, vraImg, vsImg, wagImg, zenithImg,
];

/* ================= ITEM ================= */

const ClientLogo = memo(({ src }) => (
  <div className="clients-logo">
    <img src={src} alt="client logo" loading="lazy" decoding="async" />
  </div>
));

ClientLogo.displayName = "ClientLogo";

/* ================= MAIN ================= */

export default function Clients() {
  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.2 }
    );
    if (containerRef.current) observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  // duplicate each row once for seamless loop
  const row1 = [...ROW1, ...ROW1];
  const row2 = [...ROW2, ...ROW2];

  return (
    <section className="clients-section" ref={containerRef}>
      <div className="clients-header">
        <p className="clients-subtitle">Trusted by Industry Leaders</p>
        <h2 className="clients-title">Our Clients</h2>
      </div>

      {/* Row 1 — scrolls left */}
      <div className="clients-row">
        <div className={`clients-track ${isVisible ? "animate-left" : ""}`}>
          {row1.map((src, i) => (
            <ClientLogo key={`r1-${i}`} src={src} />
          ))}
        </div>
      </div>

      {/* Row 2 — scrolls right */}
      <div className="clients-row">
        <div className={`clients-track ${isVisible ? "animate-right" : ""}`}>
          {row2.map((src, i) => (
            <ClientLogo key={`r2-${i}`} src={src} />
          ))}
        </div>
      </div>
    </section>
  );
}
